// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1Sbc1","buttons":"SendReceipts_buttons__34HTQ","email":"SendReceipts_email__x6vMH","bookApptTitle":"SendReceipts_bookApptTitle__2QSXa"};